import React from "react";
import AttendanceReport from "../components/attendance/AttendanceReport";

const Attendance = props => {
  return (
    <div>
      <AttendanceReport />
    </div>
  );
};

export default Attendance;
